import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { Device } from "../../../devices.model_new";
import {
  ClimatizationDeviceTypesMap,
  ClimatizationDeviceType,
  STATE_VAR,
  DeviceType,
} from "../../../devices.constant";
import { HVACModel } from "../../../devices.utils";
import { DevicesService } from "../../../devices.service";
import { MatSliderChange } from "@angular/material/slider";
import { IotService } from "../../../../../core/services/iot.service";
import { EditDialogComponent } from "../../edit-dialog/edit-dialog.component";
import { MatDialog, MatDialogRef } from "@angular/material";
import { Subscription } from "rxjs";
import * as jquery from "jquery";

@Component({
  selector: "app-airconditioning-detail",
  templateUrl: "./airconditioning-detail.component.html",
  styleUrls: ["./airconditioning-detail.component.scss"],
})
export class AirconditioningDetailComponent implements OnInit, OnDestroy {
  @Input() device: Device;
  hvacModel: HVACModel;
  selectedHVACTemp: number;
  selectedSpeed: number;
  maxSpeed: number;
  ClimatizationDeviceTypesMap = ClimatizationDeviceTypesMap;
  ClimatizationDeviceType = ClimatizationDeviceType;
  DeviceType = DeviceType;
  brands: string[];
  loading: boolean;
  absentModelandBrand = false;
  dialogRef: MatDialogRef<EditDialogComponent>;

  realTimeSubscription: Subscription;

  constructor(
    private iotService: IotService,
    private devicesService: DevicesService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.loading = true;
    this.iotService.connect();
    this.selectedHVACTemp = Number(this.device.getStateVar("setpoint").value);
    const appendId = setInterval(() => {
      if ($("span.mat-slider-thumb-label-text").length === 1) {
        $("span.mat-slider-thumb-label-text").append("°");
        clearInterval(appendId);
      }
    }, 0);
    this.loadComponent();
    this.obtainRealTimeResponses();
  }

  loadComponent() {
    const brand = this.device.getUserAttribute("brand");
    const model = this.device.getUserAttribute("model");

    if (!this.invalidState(brand) || !this.invalidState(model)) {
      this.devicesService
        .getHavcBrandsandModel(brand, model)
        .subscribe((hvacResponse) => {
          this.hvacModel = hvacResponse;

          this.selectedSpeed = this.device.getStateVar("fanSpeed").value;
          this.maxSpeed = Math.max.apply(Math, this.hvacModel.supportFanSpeed);
          this.loading = false;
          this.absentModelandBrand = false;
        });
    } else {
      this.loading = false;
      this.absentModelandBrand = true;
    }
  }

  getProperties(type: string) {
    return ClimatizationDeviceTypesMap.map.get(
      ClimatizationDeviceType.AIR_CONDITIONING
    ).properties[type];
  }

  getMinHVACTemp() {
    return this.hvacModel && this.hvacModel.minTemp;
  }

  getMaxHVACTemp() {
    return this.hvacModel && this.hvacModel.maxTemp;
  }

  presetTemp(device: Device, value: string, realTime: boolean) {
    this.iotService.updateModule(this.device, STATE_VAR.SETPOINT, value);
  }

  presetTempByStep(temp: string, realTime: boolean) {
    this.presetTemp(this.device, temp, realTime);
  }

  onTempChange(event: MatSliderChange) {
    this.selectedHVACTemp = event.value;
    this.presetTempByStep(String(event.value), true);
  }

  onSpeedChange(event: MatSliderChange) {
    this.iotService.updateModule(
      this.device,
      STATE_VAR.FAN_SPEED,
      String(event.value)
    );
  }

  operationMode(device: Device, value: string, realTime: boolean) {
    this.iotService.updateModule(this.device, STATE_VAR.OPERATION_MODE, value);
  }

  verticalSwing(device: Device, value: string, realTime: boolean) {
    this.iotService.updateModule(this.device, STATE_VAR.VERTICAL_SWING, value);
  }

  horizontalSwing(device: Device, value: string, realTime: boolean) {
    this.iotService.updateModule(
      this.device,
      STATE_VAR.HORIZONTAL_SWING,
      value
    );
  }

  fanSpeed(device: Device, value: string, realTime: boolean) {
    const key = "FanSpeed";
    return this.devicesService
      .executeCommand(device.getModuleLocalId(), key, value, realTime)
      .subscribe((res) => (device.getStateVar(key).value = value));
  }

  loadingScreen() {
    return (
      this.iotService.isUpdatingModule(this.device.getModuleLocalId()) ||
      this.loading
    );
  }

  private obtainCachedResponses(): void {
    this.iotService.responseHistory.forEach((message, moduleLocalId) => {
      this.processMessage(message);
    });
  }

  private obtainRealTimeResponses(): void {
    this.obtainCachedResponses();
    if (this.iotService.messagesObserver) {
      this.realTimeSubscription = this.iotService.messagesObserver.subscribe(
        (message) => {
          this.processMessage(message);
        }
      );
    }
  }

  private processMessage(message: any): void {
    if (this.device !== undefined) {
      const platformKey = message.platformKey;
      if (platformKey !== STATE_VAR.CONNECTIVITY_STATE) {
        if (platformKey === "setpoint") {
          this.selectedHVACTemp = message.value;
        }
        if (platformKey === "fanSpeed") {
          this.selectedSpeed = message.value;
        }
        const statVar = this.device.getStateVar(platformKey);
        if (statVar) {
          statVar.value = message.value;
        }
      } else {
        this.device.setConnectivityState(message.value);
      }
    }
  }

  ngOnDestroy() {
    if (this.realTimeSubscription) {
      this.realTimeSubscription.unsubscribe();
    }
  }

  openDialog(): void {
    this.dialogRef = this.dialog.open(EditDialogComponent, {
      data: {
        device: this.device,
      },
      autoFocus: false,
      panelClass: "editPopup",
    });
    if (this.device.getType() === DeviceType.CLIMATIZATION) {
      this.device.getGroups().forEach((group) => {
        if (
          ClimatizationDeviceTypesMap.map
            .get(ClimatizationDeviceType.AIR_CONDITIONING)
            .groups.includes(group)
        ) {
          const Categories = this.dialogRef.componentInstance.categoryUpdate.subscribe(
            (update: number[]) => {
              this.device.setUserAttribute("brand", update[0]);
              this.device.setUserAttribute("model", update[1]);
              const brand = this.device.getUserAttribute("brand");
              const model = this.device.getUserAttribute("model");
              this.loadComponent();
            }
          );
        }
        const Name = this.dialogRef.componentInstance.action.subscribe(
          (name: string) => {
            this.device.setName(name);
          }
        );
      });
    }
  }
  configureNow() {
    this.openDialog();
  }

  invalidState(state) {
    return state === "NULL" || state === undefined || state === null;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/devices/device-detail/climatization-detail/airconditioning-detail/airconditioning-detail.component.ts